import React from "react";

const LoadingSkeleton = () => {
  return (
    <div className="placeholder-glow d-flex flex-column gap-4">
      <span className="placeholder placeholder-lg bg-secondary col-12"></span>
      <span className="placeholder placeholder-lg bg-secondary col-8"></span>
      <span className="placeholder placeholder-lg bg-secondary col-4"></span>
    </div>
  );
};

export default LoadingSkeleton;
